(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  function setUgearsSearchQuery(form) {
    const input = form.querySelector('[data-ugears-search-input]');
    const query = form.querySelector('[data-ugears-search-query]');
    if (!input || !query) return;

    const term = input.value.trim();
    if (!term) return;

    const escapedTerm = term.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    query.value = `title:UGEARS AND "${escapedTerm}"`;
  }

  document.addEventListener('submit', (event) => {
    if (event.target.matches('[data-ugears-search-form]')) {
      setUgearsSearchQuery(event.target);
    }
  }, true);

  document.addEventListener('formdata', (event) => {
    if (event.target.matches('[data-ugears-search-form]')) {
      setUgearsSearchQuery(event.target);
      event.formData.set('q', event.target.querySelector('[data-ugears-search-query]').value);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugears-chrome"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function addUgearsView(value) {
      try {
        var url = new URL(value, window.location.origin);
        url.searchParams.set('view', 'ugears');
        return url.pathname + url.search + url.hash;
      } catch (error) {
        return value;
      }
    }

    function applyUgearsView() {
      document.querySelectorAll('#product-grid a[href*="/products/"], .related-products a[href*="/products/"]').forEach(function (link) {
        link.href = addUgearsView(link.href);
      });

      document.querySelectorAll('#product-grid [data-product-url*="/products/"], .related-products [data-product-url*="/products/"]').forEach(function (element) {
        element.setAttribute('data-product-url', addUgearsView(element.getAttribute('data-product-url')));
      });
    }

    function prepareUgearsFilterForm(form) {
      var input = form.querySelector('input[name="view"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'view';
        form.appendChild(input);
      }
      input.setAttribute('value', 'ugears');
      input.defaultValue = 'ugears';
      input.value = 'ugears';
    }

    function applyUgearsCollectionState() {
      document.querySelectorAll('#FacetFiltersForm, #FacetFiltersFormMobile, #FacetFiltersPillsForm').forEach(function (form) {
        prepareUgearsFilterForm(form);
      });

      document.querySelectorAll('.pagination a[href], .active-facets a[href], facet-remove a[href]').forEach(function (link) {
        link.href = addUgearsView(link.href);
      });
    }

    function bindUgearsCategoryControls() {
      document.querySelectorAll('[data-ugears-category-control]').forEach(function (control) {
        if (control.dataset.ugearsMenuBound === 'true') return;

        var button = control.querySelector('.ugears-context__menu-toggle');
        var menu = control.querySelector('.ugears-context__category-nav');
        if (!button || !menu) return;

        control.dataset.ugearsMenuBound = 'true';
        button.addEventListener('click', function () {
          var isOpen = menu.classList.toggle('is-open');
          button.setAttribute('aria-expanded', String(isOpen));
        });
      });
    }

    function initialiseUgearsChrome() {
      bindUgearsCategoryControls();
      applyUgearsView();
      applyUgearsCollectionState();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialiseUgearsChrome);
    } else {
      initialiseUgearsChrome();
    }

    window.addEventListener('load', applyUgearsCollectionState);
    document.addEventListener('change', function (event) {
      var form = event.target.closest && event.target.closest('#FacetFiltersForm, #FacetFiltersFormMobile, #FacetFiltersPillsForm');
      if (form) prepareUgearsFilterForm(form);
    }, true);
    document.addEventListener('submit', function (event) {
      if (event.target.matches('#FacetFiltersForm, #FacetFiltersFormMobile, #FacetFiltersPillsForm')) {
        prepareUgearsFilterForm(event.target);
      }
    }, true);
    document.addEventListener('formdata', function (event) {
      if (event.target.matches('#FacetFiltersForm, #FacetFiltersFormMobile, #FacetFiltersPillsForm')) {
        event.formData.set('view', 'ugears');
      }
    });

    document.addEventListener('shopify:section:load', initialiseUgearsChrome);
    new MutationObserver(function () {
      applyUgearsView();
      applyUgearsCollectionState();
    }).observe(document.body, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugears-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bindUgearsLandingCategoryControls() {
      document.querySelectorAll('[data-ugears-landing-category-control]').forEach(function (control) {
        if (control.dataset.ugearsLandingMenuBound === 'true') return;

        var button = control.querySelector('.ugears-nav__menu-toggle');
        var menu = control.querySelector('.ugears-nav__category-links');
        if (!button || !menu) return;

        control.dataset.ugearsLandingMenuBound = 'true';
        button.addEventListener('click', function () {
          var isOpen = menu.classList.toggle('is-open');
          button.setAttribute('aria-expanded', String(isOpen));
        });
      });
    }

    function addUgearsView(value) {
      try {
        var url = new URL(value, window.location.origin);
        url.searchParams.set('view', 'ugears');
        return url.pathname + url.search + url.hash;
      } catch (error) {
        return value;
      }
    }

    function applyUgearsProductLinks() {
      document.querySelectorAll('.ugears-products a[href*="/products/"]').forEach(function (link) {
        link.href = addUgearsView(link.href);
      });

      document.querySelectorAll('.ugears-products [data-product-url*="/products/"]').forEach(function (element) {
        element.setAttribute('data-product-url', addUgearsView(element.getAttribute('data-product-url')));
      });
    }

    function initialiseUgearsLanding() {
      bindUgearsLandingCategoryControls();
      applyUgearsProductLinks();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialiseUgearsLanding);
    } else {
      initialiseUgearsLanding();
    }

    document.addEventListener('shopify:section:load', initialiseUgearsLanding);
  })();

  } catch(e) { console.error(e); }
})();
})();
